import yachtEnginesApiService from '@/services/api/YachtEngines'

const emptyModel = {
  id: null,
  manufacturer: null,
  model: null,
  power: null
}

const emptyFilters = {
  manufacturer: null,
  model: null
}

export default class YachtEngine {
  static api = yachtEnginesApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
